<template>
  <el-dialog
    :visible.sync="newVisible"
    :before-close="handleClose"
    title="选择素材"
    width="800px">
    <AppMaterial
      id="image"
      :is-mul="isMul"
      @success="success"
      @cancel="handleClose"
    />
  </el-dialog>
</template>

<script>
import AppMaterial from '../../../components/AppMaterial/index.vue';

export default {
    name: "EditFlash",
    components: {
      AppMaterial,
    },
    props: {
      visible: {
          type: Boolean,
          default: false,
      },
      // 是否多选
      isMul: {
          type: Boolean,
          default: false,
      },
    },
    data() {
      return {
        newVisible: this.visible,
      };
    },
    watch: {
        visible(vl) {
          this.newVisible = vl;
        },
      newVisible(vl) {
          this.$emit('update:visible', vl);
      },
    },
    methods: {
      handleClose() {
        this.newVisible = false;
      },
      success(url, id, data) {
        console.log(url, id, data);
        this.handleClose();
        this.$emit('success', url, data, this.isMul);
      },
    },
};
</script>

<style scoped>

</style>
